/**
 * 공장·설비 목록.
 *
 * 기본값은 이식 당시의 상수(베트남 52 + 동탄 4)이고, 실데이터 연결 후에는 서버 스냅샷의
 * 공장·설비 목록으로 교체된다(applyTopology). 배열을 제자리에서 바꾸므로 이 모듈을 import 한
 * 모든 곳(그래프 골격·사이드바·상세 패널·배치)이 같은 목록을 본다.
 */
const LEGACY_PREFIX = {
    vietnam: "opcua_multi_",
    dongtan: "opcua_multi_dongtan_",
};
export const FACTORIES = [
    {
        id: "vietnam",
        label: "베트남",
        name: "베트남 공장",
        machineCount: 52,
        legacyTablePrefix: "opcua_multi_",
    },
    {
        id: "dongtan",
        label: "동탄",
        name: "동탄 공장",
        machineCount: 4,
        legacyTablePrefix: "opcua_multi_dongtan_",
    },
];
export const FACTORY_IDS = FACTORIES.map((f) => f.id);
function pad2(n) {
    return n < 10 ? `0${n}` : String(n);
}
export const MACHINES = FACTORIES.flatMap((f) => Array.from({ length: f.machineCount }, (_, i) => {
    const num = pad2(i + 1);
    return {
        factoryId: f.id,
        machineId: `M${num}`,
        label: `${f.label} ${num}호기`,
    };
}));
/**
 * 서버 스냅샷의 공장·설비 목록으로 교체한다. 설비 순서는 공장 순서 → 호기 번호.
 * 서버가 목록을 주지 않으면(빈 배열) 기존 목록을 유지한다.
 */
export function applyTopology(serverFactories, serverMachines) {
    if (!Array.isArray(serverFactories) || serverFactories.length === 0)
        return;
    const factories = serverFactories.map((f) => ({
        id: f.slug,
        label: f.label || f.factoryName || f.slug,
        name: f.factoryName || f.label || f.slug,
        machineCount: f.machineCount ?? 0,
        legacyTablePrefix: LEGACY_PREFIX[f.slug] ?? `opcua_multi_${f.slug}_`,
        factoryId: f.factoryId,
        factoryCode: f.factoryCode,
    }));
    const order = Object.fromEntries(factories.map((f, i) => [f.id, i]));
    const machines = (Array.isArray(serverMachines) ? serverMachines : [])
        .map((m) => ({
            factoryId: m.slug,
            machineId: m.machineId,
            label: m.equipmentName || `${m.slug} ${m.machineId}`,
            equipmentId: m.equipmentId,
            equipmentCode: m.equipmentCode,
        }))
        .sort((a, b) => (order[a.factoryId] ?? 99) - (order[b.factoryId] ?? 99)
            || Number(a.machineId.slice(1)) - Number(b.machineId.slice(1)));
    FACTORIES.splice(0, FACTORIES.length, ...factories);
    FACTORY_IDS.splice(0, FACTORY_IDS.length, ...factories.map((f) => f.id));
    MACHINES.splice(0, MACHINES.length, ...machines);
}
